import Joi from 'joi';

const LicenseInformationInputValidator = {
  validateMultiple: async licenseInformations => {
    const validationPromises = licenseInformations.map(validateInner);
    const validationErrors = await Promise.all(validationPromises);

    return validationErrors.filter(ve => ve).flat();
  }
};

const validateInner = async licenseInformation => {
  const schema = Joi.object({
    paidTotal: Joi.number().empty(null).required().min(Joi.ref('paidAssigned')).max(9999).messages({
      'any.required': 'Enter value for Paid Total',
      'number.min': 'Paid Total licenses cannot be less than assigned licenses',
      'number.max': 'Paid Total licenses cannot be greater than 9,999'
    }),
    freeTotal: Joi.number().empty(null).required().min(Joi.ref('freeAssigned')).max(9999).messages({
      'any.required': 'Enter value for Free Total',
      'number.min': 'Free Total licenses cannot be less than assigned licenses',
      'number.max': 'Free Total licenses cannot be greater than 9,999'
    })
  }).unknown(true);

  try {
    await schema.validateAsync(licenseInformation, { abortEarly: false });
    return;
  } catch (err) {
    return err.details.map(ie => ({
      type: licenseInformation.type,
      holderId: licenseInformation.holderId,
      fieldName: ie.path.join('.'),
      message: `${licenseInformation.holderName} - ${ie.message}`
    }));
  }
};

export default LicenseInformationInputValidator;
